export const comments_5618659 = {"data":{"data":[],"links":{}}}